export default function Separator() {
  return (
    <div className="self-stretch h-0 outline outline-[1px] outline-[#05141F]" />
  );
}
